import { Button, IconButton, SvgIcon } from "@mui/material";
import React from "react";
import { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import CloseIcon from "@mui/icons-material/Close";
import { ReactComponent as Upload } from "../../../../assets/images/Upload-Red.svg";

import "./DocUpload.scss";
import { useDispatch, useSelector } from "react-redux";
import { uploadDoc } from "../../../../redux/actions/dataActions";
import { close } from "../../../../redux/actions/modalActions";
const DocUpload = () => {
  const { data, current_doc, files_sent, files_error } = useSelector((state) => state.data);
  const { loading } = useSelector((state) => state.async);
  const dispatch = useDispatch();
  const fileTypes = ["JPG", "PNG", "GIF", "PDF"];
  // const [formData] = useState( new FormData());
  const [file, setFile] = useState(null);
  const [sent, setSent] = useState(false);
  const handleChange = (file) => {
    setFile(file);
    console.log(file);
  };
  console.log(current_doc);
  console.log(file);
  const submitDocUpload = () => {
    var reader = new FileReader();
    let baseURL = "";
    
    if (file) {
      setSent(true);
      
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;

        dispatch(
          uploadDoc({
            DocType: current_doc?.documentType ?? "general",
            LicNum: data?.truckData.licNum?.replace(/-/g, ''),
            DocNum: data?.id,
            File: baseURL,
          })
        );
        
      };
    } else {
      console.log("no fileeeeeeeeee");
    }
  };
  console.log(files_sent);
 
  const getContent = () => {
    return (
      <div className="drop_area">
        <div className="upload">
          <div className="blue_back">
            <SvgIcon component={Upload} className="up_icon" inheritViewBox />
          </div>
          <div className="bold_text">העלה קובץ</div>
        </div>
        {/* <div className="divider">
            <div className="div_text">או</div>
            </div>
        <div className="QR_code">QR</div> */}
      </div>
    );
  };
  return (
    !sent ?
    <div className="upload_doc_form">
      
      <div className="content_title">
        {current_doc ? "צרף " + current_doc.label : "העלה מסמך"}
      </div>

      <FileUploader
        classes="123456"
        children={getContent()}
        onSelect={handleChange}
        onDrop={handleChange}
        
        name="file"
        types={fileTypes}
      />
      {file && (
        <div className="file_name">
          <IconButton onClick={() => setFile(undefined)}>
            {" "}
            <CloseIcon />
          </IconButton>
          {file?.name}
        </div>
      )}
      <Button
        className="submit_btn"
        variant="outlined"
        onClick={() => submitDocUpload()}
      >
        שמירה
      </Button> 
    </div> : (files_error ? <div className="upload_doc_form_mini">ארעה שגיאה בהעלאת הקובץ</div> : 
    (files_sent.some(item => item === (current_doc?.documentType || "general")) ? 
    <div className="upload_doc_form_mini">הקובץ נשלח בהצלחה</div> : <div className="upload_doc_form_mini">    טוען...    </div>))
    
  )
};

export default DocUpload;
